<template>
  <div>
    <div style="text-align: center" v-if="loading">
      <a-spin></a-spin>
    </div>
    <div v-if="!loading" id="userInfo">
      <div @click="$router.push('/search')" style="
          position: absolute;
          right: 14px;
          font-weight: bold;
          font-size: 2em;
          cursor: pointer;
          top: 0px;
          color: darkred;
        ">
        X
      </div>

      <div style="font-size: 1.8em">
        <strong>{{ assureInfo.last_name }}</strong> {{ assureInfo.first_name }}
      </div>
      <div style="font-size: 1.2em; color: grey">
        <strong>N° de sécurité sociale: </strong>
        {{ assureInfo.social_security_number }}
      </div>
      <div style="font-size: 1.2em; color: grey">
        <strong>Entreprise: </strong> {{ assureInfo.company }}
      </div>

      <a-divider></a-divider>

      <div style="display: flex">
        <div class="ai_card" style="min-width: 460px; margin-right: 20px">
          <div>
            {{ assureInfo.address }}
            {{ assureInfo.additional_address }}, {{ assureInfo.zip_code }}
            {{ assureInfo.city }}
            <sup v-if="assureInfo.npai" style="color: darkred; font-weight: bold">
              NPAI
            </sup>
          </div>
          <div>
            {{ assureInfo.email }}
          </div>
          <div>
            {{ assureInfo.tel_home }}
          </div>
          <div>
            {{ assureInfo.tel_mobile }}
          </div>
        </div>

        <div>
          <div class="ai_card">
            <strong>Ayant(s) droit : </strong>
            {{ assureInfo.benefs?.length }}
          </div>

          <div class="ai_card">
            <strong>Télétransmission : </strong>
            {{ translate.connecte[assureInfo.connecte] }}
          </div>

          <div class="ai_card">
            <strong>IBAN : </strong>
            {{ assureInfo.bank?.account_number }}
          </div>

          <div class="ai_card">
            <strong>Carte tiers payant : </strong>
            {{ assureInfo.ctd }}

            <span v-if="assureInfo.is_carte_tp == '0'">Indisponible</span>

            <a-button v-else :href="assureInfo.carte_tp_uuid" type="link">
              Télécharger
            </a-button>
          </div>
        </div>
      </div>

      <div v-if="assureInfo.attestations && assureInfo.attestations.length">
        <div style="
            font-size: 1.4rem;
            padding-bottom: 10px;
            border-bottom: 1px solid #ccc;
            margin-bottom: 10px;
            font-weight: bold;
            ">
          Attestations
        </div>

        <div v-for="att in assureInfo.attestations" :key="att.id">
          <div class="ai_card" style="margin-bottom: 10px">
            <div>
              <a
                :href="att.download_link"
                :download="att.filename"
                style="display: flex; align-items: center; gap: 8px; color: #1890ff; text-decoration: none;"
              >
                <a-button type="link" style="padding: 0;">
                  <template #icon>
                    <i class="anticon anticon-download" />
                  </template>
                  {{ att.type === 'madelin' ? 'Madelin' : 'Frais Généraux' }} ({{ att.date_attestation.substring(0, 4) }}) - {{ att.filename }}
                </a-button>
              </a>
            </div>
          </div>
        </div>
      </div>

      <a-divider></a-divider>

      <div v-if="isEcheancier">
        <div style="
            font-size: 1.4rem;
            padding-bottom: 10px;
            border-bottom: 1px solid #ccc;
            margin-bottom: 10px;
            font-weight: bold;
            ">
          Echeancier
        </div>


        <div v-for="e in assureInfo.echeanciers" :key="e.download_link">
          <div class="ai_card" style="margin-bottom: 10px">
            <div>
              <a
                :href="e.download_link"
                :download="e.filename"
                style="display: flex; align-items: center; gap: 8px; color: #1890ff; text-decoration: none;"
              >
                <a-button type="link" style="padding: 0;">
                  <template #icon>
                    <i class="anticon anticon-download" />
                  </template>
                  {{ e.filename }}
                </a-button>
              </a>
            </div>
          </div>
        </div>
      </div>

      <a-divider></a-divider>

      <div v-if="true" class="as_contrat">
        <div style="
            font-size: 1.4rem;
            padding-bottom: 10px;
            border-bottom: 1px solid #ccc;
            margin-bottom: 10px;
            font-weight: bold;
          ">
          Contrat
        </div>

        <div style="margin-bottom: 32px" v-for="c in assuresContracts" :key="c.contract.internal_number">
          <div class="asc_title">
            {{ c.contract.name }} - {{ c.contract.prisq2 }} - {{ c.contract.police }}{{ c.contract.cpid }}
          </div>

          <a-row style="font-weight: bold; margin-bottom: 8px">
            <a-col :span="4"></a-col>
            <a-col :span="5">Date de naissance</a-col>
            <a-col :span="5">Date d'entrée</a-col>
            <a-col :span="5">Date de sortie</a-col>

            <a-col :span="5">
              <span v-if="c.contract.type_contract === '01'">
                Télétransmission
              </span>
            </a-col>
          </a-row>

          <a-row v-for="a in c.family" :key="a.key">
            <a-col :span="4">
              <strong>{{ a.type }}</strong>
            </a-col>
            <a-col :span="5">{{ a.birth_date }}</a-col>
            <a-col :span="5">{{ a.dea }}</a-col>
            <a-col :span="5">{{ a.dsa }}</a-col>
            <a-col :span="5">
              <span v-if="c.contract.type_contract === '01'">
                {{ translate.connecte[a.connecte] }}
              </span>
            </a-col>
          </a-row>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "AssureTable",
  data: function () {
    return {
      loading: true,
      assureInfo: {
        assures_contracts: [],
      },
    };
  },
  watch: {},
  methods: {
    getAssureType(tp) {
      if (tp == "A") return "Assuré";
      else if (tp == "E") return "Enfant";
      else return "Conjoint";
    },
  },
  computed: {
    isEcheancier() {
      return this.assureInfo.echeanciers && this.assureInfo.echeanciers.length > 0;
    },
    assuresContracts() {
      return this.assureInfo.assures_contracts
        .filter((c) => {
          if (c.contract.contract_type) {
            c.contract_name =
              c.contract.name + "/" + c.contract.police + c.contract.cpid;

            c.family = [];

            c.family.push({
              key: c.assure_internal_number,
              type: "Assuré",
              birth_date: this.assureInfo.birth_date,
              dea: c.dea,
              dsa: c.dsa,
              connecte: c.connecte,
            });

            this.assureInfo.benefs.map((b) => {
              let bContract = b.benefs_contracts.find(
                (bc) =>
                  bc.contract_internal_number == c.contract_internal_number
              );

              if (bContract != undefined) {
                let type = b.family_type === "E" ? "Enfant" : "Conjoint";

                c.family.push({
                  key: b.assure_internal_number,
                  type: type,
                  birth_date: b.birth_date,
                  dea: bContract.dea,
                  dsa: bContract.dsa,
                  connecte: bContract.connecte,
                });
              }
            });

            return c;
          }
        })
        .reverse()
        .sort((a, b) => {
          if (a.contract.type_contract > b.contract.type_contract) {
            return 1;
          } else if (a.contract.type_contract < b.contract.type_contract) {
            return -1;
          } else {
            return 0;
          }
        });
    },
    translate() {
      return this.$store.getters.translate;
    },
  },
  mounted() {
    this.axios
      .get(
        `/data/assures/${this.$route.params.holdingIN}/${this.$route.params.companyIN}/${this.$route.params.numSS}`
      )
      .then((r) => {
        this.assureInfo = r.data.assureInfo;

        setTimeout(() => {
          this.loading = false;
        }, 100);
      });
  },
};
</script>

<style scoped>
.ai_card {
  padding: 10px;
  margin-bottom: 10px;
  box-shadow: 0 0 1px 0 rgb(44, 44, 44);
  border-radius: 10px;
  background-color: #f9f9f9;
  min-width: 280px;
}

.asc_title {
  border-bottom: 1px solid darkgreen;
  padding-bottom: 6px;
  margin-bottom: 6px;
  font-weight: bold;
  color: brown;
}
</style>
